import { render } from "./InvestasiDetailSektor.vue?vue&type=template&id=2feb2cbf"
import script from "./InvestasiDetailSektor.vue?vue&type=script&lang=js"
export * from "./InvestasiDetailSektor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__